//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class TourConstants
{
	public static colorRegexPattern: string = `^#(([0-9a-fA-F]{2}){3})$`;
}
